import Plyr from 'plyr';
export function initLaboratoire(){

	var laboratoire = Barba.BaseView.extend({
		namespace: 'laboratoire',
		onEnter: function() {
		// The new Container is ready and attached to the DOM.



		//const player = new Plyr('#player');

		var mySwiper = new Swiper ('.classic-block--slider', {
			// Optional parameters
			loop: true,
			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		})

		var mySwiper = new Swiper ('.testimonies--slider', {
			// Optional parameters
			loop: false,
			slidesPerView: 1,
			spaceBetween: 16,
			// Navigation arrows
			navigation: {
				nextEl: '.testimonies-button-next',
				prevEl: '.testimonies-button-prev',
			},
			breakpoints: {
				992: {
					slidesPerView: 2,
					spaceBetween: 16
				}
			}
		})
	},
	onEnterCompleted: function() {
		// The Transition has just finished.
	}
});
  // Don't forget to init the view!
  laboratoire.init();

}
